const Railcards = [
  {
    code: "2TR",
    name: "Two Together Railcard"
  },
  {
    code: "DIC",
    name: "Disabled Child Railcard"
  },
  {
    code: "DIS",
    name: "Disabled Persons Railcard"
  },
  {
    code: "FAM",
    name: "Family & Friends Railcard"
  },
  {
    code: "HMF",
    name: "HM Forces Railcard"
  },
  {
    code: "JCP",
    name: "Jobcentre Plus Travel Discount Card"
  },
  {
    code: "NEW",
    name: "Network Railcard"
  },
  {
    code: "NGC",
    name: "Annual Gold Card"
  },
  {
    code: "SRN",
    name: "Senior Railcard"
  },
  {
    code: "TST",
    name: "26-30 Railcard"
  },
  {
    code: "TSU",
    name: "16-17 Saver"
  },
  {
    code: "VET",
    name: "Veterans Railcard"
  },
  {
    code: "YNG",
    name: "16-25 Railcard"
  }
];

export default Railcards;
